import { render, staticRenderFns } from "./FormMenu.vue?vue&type=template&id=6ae8def2&lang=pug&"
import script from "./FormMenu.vue?vue&type=script&lang=js&"
export * from "./FormMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports